// extracted by mini-css-extract-plugin
export default {"why":"why_why__6NIbq","whyContainer":"why_whyContainer__BamsY","whyTitle":"why_whyTitle__IyZtz","whyContent":"why_whyContent__1rncB"};